    // src/utils/saveConfirmation.js
const withSaveConfirmation = (onSubmit) => async (data, setSuccessMessage, setWarningMessage, navigate, editData) => {
  // Show confirmation dialog
  const confirmSave = window.confirm('Do you want to save this record?');
  if (!confirmSave) {
    return; // User clicked "No"
  }

  // Show warning about non-editable records
  const confirmNonEditable = window.confirm(
    'Once you save, you cannot edit this record. Are you sure?'
  );
  if (!confirmNonEditable) {
    return; // User clicked "No"
  }

  // Proceed with the original submission
  try {
    await onSubmit(data);
    setSuccessMessage(editData ? 'Updated successfully' : 'Added successfully');
    setWarningMessage('');
    setTimeout(() => navigate(-1), 1000);
  } catch (error) {
    setSuccessMessage('');
    setWarningMessage('Error occurred during submission.');
  }
};

export default withSaveConfirmation;